//Generated File 
export default class Operator{
	static readonly CloseBracket = `CloseBracket`;
	static readonly Contains = `Contains`;
	static readonly EndsWith = `EndsWith`;
	static readonly Equal = `Equal`;
	static readonly GreaterThan = `GreaterThan`;
	static readonly GreaterThanOrEqual = `GreaterThanOrEqual`;
	static readonly In = `In`;
	static readonly LessThan = `LessThan`;
	static readonly LessThanOrEqual = `LessThanOrEqual`;
	static readonly NotContain = `NotContain`;
	static readonly NotEndWith = `NotEndWith`;
	static readonly NotEqual = `NotEqual`;
	static readonly NotIn = `NotIn`;
	static readonly NotStartsWith = `NotStartsWith`;
	static readonly OpenBracket = `OpenBracket`;
	static readonly OutsidePeriod = `OutsidePeriod`;
	static readonly StartsWith = `StartsWith`;
	static readonly WithinPeriod = `WithinPeriod`;
}
